import { render, staticRenderFns } from "./ChurchList.vue?vue&type=template&id=1da7b974&"
import script from "./ChurchList.vue?vue&type=script&lang=js&"
export * from "./ChurchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChurchList.vue"
export default component.exports